/* 🤖 this file was generated by svg-to-ts */
export const mgcIconComputerFilled: {
  name: 'computer-filled';
  data: string;
} = {
  name: 'computer-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 3.047c-.733.14-1.4.821-1.537 1.57-.06.333-.06 11.433 0 11.766.141.768.806 1.433 1.574 1.574.151.027.994.043 2.31.043H9v1h-.573c-.686 0-.881.052-1.128.299a.984.984 0 0 0 0 1.402c.317.317.038.299 4.701.299s4.384.018 4.701-.299a.984.984 0 0 0 0-1.402c-.247-.247-.442-.299-1.128-.299H15v-1h2.073c1.316 0 2.159-.016 2.31-.043.768-.141 1.433-.806 1.574-1.574.06-.333.06-11.433 0-11.766-.141-.768-.806-1.433-1.574-1.574-.307-.056-14.508-.052-14.803.004M13 18.5v.5h-2v-1h2z"/></svg>`
};
